<div class="py-8" *transloco="let t">
  <div class="mb-6 flex flex-col gap-1">
    <h4>{{ t("sb-form-format.title") }}</h4>
    <p class="type-body text-muted-foreground m-0">{{ t("sb-form-format.description") }}</p>
  </div>

  @if (storePageLoading()) {
    <div class="flex justify-center py-12">
      <ISpinner [display]="true" />
    </div>
  } @else {
    <IRadioGroup
      name="sbCreativeType"
      class="flex flex-col gap-2"
      [value]="format().sbCreativeType().value()"
      (valueChange)="selectCreativeType($event)"
    >
      @for (creativeType of creatableFormats; track creativeType) {
        @let isBrandVideoWithoutStorePages = creativeType === SbCreativeType.brandVideo && storeRelatedFormatDisabled();
        @let isStoreSpotlightDisabled = creativeType === SbCreativeType.storeSpotlight && disableStoreSpotlight();
        @let isStoreSpotlightWithoutStore =
          creativeType === SbCreativeType.storeSpotlight && !isStoreSpotlightDisabled && storeSpotlightStoresDisabled();
        @let isManualCollectionDisabled = creativeType === SbCreativeType.manualCollection && disableManualCollection();
        @let isFormatDisabled =
          isBrandVideoWithoutStorePages ||
          isStoreSpotlightDisabled ||
          isStoreSpotlightWithoutStore ||
          isManualCollectionDisabled;
        <label
          iLabel
          type="card"
          class="w-full"
          [for]="creativeType"
          [disabled]="isFormatDisabled"
          [attr.data-testid]="'ad-format-card-' + creativeType"
        >
          <div>
            <span class="type-body-medium">{{ t(titles[creativeType]) }}</span>
            <p class="text-muted-foreground m-0">{{ t(descriptions[creativeType]) }}</p>
          </div>
          <IRadio [id]="creativeType" [value]="creativeType" size="lg" [disabled]="isFormatDisabled" />

          <div iLabelStatus>
            @if (isBrandVideoWithoutStorePages) {
              <app-sb-format-card-status
                [status]="SbFormatCardStatus.NoStoreAvailable"
                [brandName]="selectedBrand()?.brandName"
              />
            }
            @if (isStoreSpotlightWithoutStore) {
              <app-sb-format-card-status
                [status]="SbFormatCardStatus.NoStoreSpotlightStoreAvailable"
                [brandName]="selectedBrand()?.brandName"
              />
            }
            @if (isStoreSpotlightDisabled) {
              <app-sb-format-card-status [status]="SbFormatCardStatus.StoreSpotlightFormatNotAvailable" />
            }
            @if (isManualCollectionDisabled) {
              <app-sb-format-card-status [status]="SbFormatCardStatus.ManualCollectionFormatNotAvailable" />
            }
          </div>

          @if (creativeType === SbCreativeType.manualCollection) {
            <div content class="mt-5 flex flex-col gap-2.5 border-t pt-5 pb-1">
              <IRadioGroup
                name="sbLandingPage"
                class="flex flex-col gap-2.5 px-2.5"
                [value]="format().sbLandingPage().value()"
                (valueChange)="selectLandingPage($event)"
              >
                <label iLabel class="flex cursor-pointer items-center gap-3" [for]="LandingPage.ProductListing">
                  <IRadio
                    [id]="LandingPage.ProductListing"
                    [value]="LandingPage.ProductListing"
                    size="lg"
                    testId="ProductListing-radio"
                  />
                  <span class="type-body-medium text-foreground">{{ t("sb-form-ad-format.product_listing") }}</span>
                </label>
                <label
                  iLabel
                  class="flex items-center gap-3"
                  [class.cursor-pointer]="!storeRelatedFormatDisabled()"
                  [for]="LandingPage.Store"
                  [disabled]="storeRelatedFormatDisabled()"
                >
                  <IRadio
                    [id]="LandingPage.Store"
                    [value]="LandingPage.Store"
                    size="lg"
                    testId="Store-radio"
                    [disabled]="storeRelatedFormatDisabled()"
                  />
                  <span class="type-body-medium text-foreground">{{ t("sb-form-ad-format.store_page") }}</span>
                </label>
                @if (storeRelatedFormatDisabled()) {
                  <app-sb-format-card-status
                    [status]="SbFormatCardStatus.NoStoreAvailable"
                    [brandName]="selectedBrand()?.brandName"
                  />
                }
              </IRadioGroup>

              @if (format().sbLandingPage().value() === LandingPage.Store) {
                <app-store-select-menu
                  class="px-2.5"
                  [label]="t('creative-display.store_page')"
                  [stores]="storePages()"
                  [storeSpotlightAvailableStores]="spotlightAvailableStores()"
                  [selectedStorePage]="format().store().value()"
                  (selectedStorePageChange)="selectStorePage($event)"
                />
              }
            </div>
          } @else if (creativeType === SbCreativeType.brandVideo || creativeType === SbCreativeType.storeSpotlight) {
            <div content class="mt-5 flex flex-col gap-2.5 border-t pt-5 pb-1">
              @let isStoreSpotlight = creativeType === SbCreativeType.storeSpotlight;
              <app-store-select-menu
                class="px-2.5"
                [label]="isStoreSpotlight ? t('sb-form-ad-format.store') : t('creative-display.store_page')"
                [mode]="isStoreSpotlight ? 'store' : 'page'"
                [stores]="storePages()"
                [storeSpotlightAvailableStores]="spotlightAvailableStores()"
                [selectedStorePage]="format().store().value()"
                (selectedStorePageChange)="selectStorePage($event)"
              />
            </div>
          }
        </label>
      }
    </IRadioGroup>
  }
</div>
